module.exports = __webpack_public_path__ + "heart-anatomy.9b4e8fabed0d5d56c4d90be1258b4a21.png";